export enum ProjectDistributorStatusEnum {
    ACTIVE,
    INACTIVE
}
